export type HelpDownloadItem = {
  id: string;
  title: string;
  subtitle: string;
  previewImageUrl: string;
  downloadUrl: string;
};

const CLOUDINARY_UPLOAD_BASE =
  'https://res.cloudinary.com/klydoclock/image/upload';
const KLYDO_TEMPLATE_PATH =
  'v1785933462/tickets/6a732e9496a2150c789e4a0c/xolhqltxyrfmmqfxai5n.png';

export const HELP_DOWNLOADS: HelpDownloadItem[] = [
  {
    id: 'klydo-template',
    title: 'Klydo Template',
    subtitle: 'Design your animation on this overlay.',
    previewImageUrl: `${CLOUDINARY_UPLOAD_BASE}/${KLYDO_TEMPLATE_PATH}`,
    downloadUrl: `${CLOUDINARY_UPLOAD_BASE}/fl_attachment:Overlay-Template/${KLYDO_TEMPLATE_PATH}`,
  },
];
